// Publish/Subscribe pattern for theme events
(function() {
  'use strict';

  let subscribers = {};

  function publish(eventName, data) {
    if (subscribers[eventName]) {
      subscribers[eventName].forEach(callback => {
        callback(data);
      });
    }
  }

  function subscribe(eventName, callback) {
    if (!subscribers[eventName]) {
      subscribers[eventName] = [];
    }
    subscribers[eventName].push(callback);
  }

  function unsubscribe(eventName, callback) {
    if (subscribers[eventName]) {
      subscribers[eventName] = subscribers[eventName].filter(cb => cb !== callback);
    }
  }

  // Make functions available globally
  window.PubSub = {
    publish: publish,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };

  // Theme-specific events
  window.themeEvents = {
    CART_UPDATED: 'cart:updated',
    PRODUCT_VARIANT_CHANGED: 'product:variantChanged',
    MOBILE_MENU_TOGGLED: 'mobile:menuToggled'
  };

})();